// extracted by mini-css-extract-plugin
module.exports = {"bundle-item":"ProductItem_bundle-item__bYT17"};